<template>
  <el-dialog
    v-if="visible"
    :visible.sync="visible"
    :title="title"
    show-close
    width="400px"
    :close-on-click-modal="false"
    :before-close="() => $refs.hsCodeForm.cancel()"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <HsCodeForm
      ref="hsCodeForm"
      :shipmentCode="shipmentCode"
      :listGoods="listGoods"
      @reload="$emit('reload')"
      @close="close()"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.hsCodeForm.cancel()">
        {{ this.$l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.hsCodeForm.save()">
        {{ this.$l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import HsCodeForm from './form.vue'
export default {
  components: { HsCodeForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    shipmentCode: { type: String, default: '' },
    listGoods: { type: Array, default: () => [] },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>

<style scoped></style>
